import { Copyright, Text } from 'shell/components';

const CopyrightDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Copyright</Text>
            <Copyright />
        </>
    );
};

export default CopyrightDemo;
